<template>
	<v-dialog v-model="showDialog" width="500" min-height="400" persistent>
		<v-card>
			<v-card-title> Add Entity </v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-text-field
						ref="Name"
						label="Name"
						v-model="name"
						:rules="[
							rules.required,
							rules.entityName,
							rules.entityNameUnique,
						]"
						hide-details="auto"
						@keydown.enter="onSave"
					></v-text-field>
				</v-form>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn @click.stop="onSave" color="primary">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { DataFieldsActions } from '../../../store/actions';
export default {
	name: 'AddEntityModal',
	props: {
		showDialog: Boolean,
		entities: Array,
	},
	computed: {
		form() {
			return {
				Name: this.name,
			};
		},
	},
	data() {
		return {
			name: null,
			rules: {
				required: (value) => !!value || 'Field is required',
				entityName: (value) => {
					const pattern = /^[A-Za-z_][A-Za-z0-9_][^\s]*$/;
					return pattern.test(value) || 'Invalid entity name format';
				},
				entityNameUnique: (value) => {
					var result = true;
					this.entities.forEach((x) => {
						if (x.Name == value) result = false;
					});

					return result || 'Entity name must be unique';
				},
			},
		};
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			if (!this.$refs.form.validate()) return;
			this.$store
				.dispatch(DataFieldsActions.ADD_ENTITY, this.form)
				.then(() => {
					this.loading = false;
					this.$emit('close');
				});
		},
	},
};
</script>
